import { getPortalId } from '../utils/getPortalId';
import { apiClientWithMiddleware } from '../utils/API';
import { captureException } from '../utils/sentryAPI';
const navPersonaApiClient = apiClientWithMiddleware();
const URL_SLUG = `navpersona/depot/v1/attribute/`;
const setAttribute = async (attributeName, value, userId) => {
  const portalId = getPortalId();
  const endpoint = userId === undefined ? `${URL_SLUG}${portalId}` : `${URL_SLUG}${portalId}/${userId}`;
  let response = null;
  try {
    response = await navPersonaApiClient.post(endpoint, {
      data: {
        personaAttributeName: attributeName,
        personaAttributeValue: value
      },
      query: {
        portalId
      }
    });
  } catch (error) {
    if (error instanceof Error) captureException(error);
  }
  return response;
};
export const navPersonaService = {
  setAttribute
};